import { MediaSymbolTypes } from '../typing/enums';
import { getAdjustedDims } from './assetHelpers';

const getImageUrl = (props, width, height, transformation, analytics, version) => {
  const {
    mediaType,
    publicId,
    context: { cloudinary }
  } = props;

  switch (mediaType) {
    case MediaSymbolTypes.VIDEO:
      return cloudinary.getVideoThumbnailUrl(
        publicId,
        width,
        height,
        transformation,
        analytics,
        version
      );
    case MediaSymbolTypes.THREE:
      return cloudinary.getThreeThumbnailUrl(
        publicId,
        width,
        height,
        transformation,
        analytics,
        version
      );
    default:
      return cloudinary.getImageUrl(publicId, width, height, transformation, analytics, version);
  }
};

const loadLowResImage = async props => {
  const {
    publicId,
    transformation,
    breakpoint,
    fetchPriority,
    version,
    context: { cacher, config }
  } = props;

  const thumbWidth = config.selectThumbnailPropsWidth();
  const thumbHeight = config.selectThumbnailPropsHeight();
  const adjDims = getAdjustedDims(thumbWidth, thumbHeight, breakpoint);
  const url = getImageUrl(props, adjDims.width, adjDims.height, transformation, {}, version);

  try {
    return await cacher(
      publicId,
      url,
      thumbWidth,
      thumbHeight,
      transformation,
      version,
      fetchPriority
    );
  } catch (error) {
    console.warn('PGW - Failed to cache low resolution image');
  }
};

const loadHighResImage = async props => {
  const {
    publicId,
    width,
    height,
    transformation,
    breakpoint,
    roundHeightToBreakpoint,
    fetchPriority,
    version,
    context: { cacher }
  } = props;
  const adjDims = getAdjustedDims(width, height, breakpoint, roundHeightToBreakpoint);
  const url = getImageUrl(props, adjDims.width, adjDims.height, transformation, {}, version);

  try {
    return await cacher(
      publicId,
      url,
      adjDims.width,
      adjDims.height,
      transformation,
      version,
      fetchPriority
    );
  } catch (error) {
    throw new Error('Failed to cache high resolution image');
  }
};

const loadZoomImage = async props => {
  const {
    publicId,
    width,
    height,
    transformation,
    breakpoint,
    roundHeightToBreakpoint,
    version,
    context: { cacher, config }
  } = props;
  const adjDims = getAdjustedDims(width, height, breakpoint, roundHeightToBreakpoint);
  const zoomLevel = config.selectZoomPropsLevel();
  const zoomWidth = adjDims.width * zoomLevel;
  const zoomHeight = adjDims.height * zoomLevel;

  const url = getImageUrl(props, zoomWidth, zoomHeight, transformation, { pgwact: 1 }, version);

  try {
    return await cacher(publicId, url, zoomWidth, zoomHeight, transformation, version);
  } catch (error) {
    throw new Error('Failed to cache zoom image');
  }
};

export default {
  loadLowResImage,
  loadHighResImage,
  loadZoomImage
};
